import React from 'react';

import { FlameTheme } from '@lightspeed/flame/Core';

import { createReactRenderer } from 'helpers/react-renderer';

import OptInModal from './OptInModal';

interface OptInCheckBoxProps {
  customerOptIn: boolean;
}

const OptInCheckBox: React.FC<OptInCheckBoxProps> = ({ customerOptIn }) => {
  const [currentCustomerOptIn, setCurrentCustomerOptIn] = React.useState<boolean | null>(
    customerOptIn
  );
  const [isOptInModalOpen, setIsOptInModalOpen] = React.useState(false);

  const handleOptInClick = () => {
    if (currentCustomerOptIn) {
      // set the checkbox state here so that we can reflect the checkbox state if the option save fails
      window.lsCloud.Options.save('customer_use_card_on_file', 'false')
        .done(() => {
          setCurrentCustomerOptIn(false);
        })
        .fail(() => {
          window.showNotifier(
            'warning',
            'Failed to Opt Out of Card on File, please try again later.'
          );
        });
    } else {
      setIsOptInModalOpen(true);
    }
  };

  return (
    <FlameTheme>
      <input
        type="checkbox"
        name="customer_use_card_on_file"
        readOnly
        onClick={(e) => {
          e.preventDefault();
          handleOptInClick();
        }}
        checked={currentCustomerOptIn || false}
        style={{ margin: '20px 0' }}
      />
      <OptInModal
        isOpen={isOptInModalOpen}
        onRequestClose={() => setIsOptInModalOpen(false)}
        onComplete={() => {
          setCurrentCustomerOptIn(true);
        }}
        swapStepTwoButtonOrder={false}
      />
    </FlameTheme>
  );
};

const RenderedComponent = createReactRenderer({
  component: OptInCheckBox,
  selector: '[data-react-root="OptInCheckBox"]',
});

export default OptInCheckBox;

history.onChangeState(
  [
    {
      name: ['admin.views.options'],
      form_name: 'view',
      tab: ['settings', 'general'],
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
